import React from 'react';
import PoweredLogo from 'assets/images/logo/vz-logo.png';
import './logo.scss';

export default () => (
  <div className="wrapper">
    <img className="powered-img" src={PoweredLogo} alt="Powered by Solution" />
  </div>
);
